import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Paper, Typography } from '@mui/material'
import ComputerIcon from '@mui/icons-material/Computer'
import useTelaPequena from './useTelaPequena'

/**
 * Telas de configuração são só para desktop (padrão P-C7). No celular mostra um aviso em vez de um
 * layout quebrado; no desktop renderiza a tela normalmente.
 *
 * @param {{ titulo?: string, children: any }} props
 */
export default function SomenteDesktop({ titulo, children }) {
  const telaPequena = useTelaPequena()
  const navigate = useNavigate()
  if (!telaPequena) return children
  return (
    <Box sx={{ p: 2 }}>
      <Paper variant="outlined" sx={{ p: 3, textAlign: 'center' }} data-testid="somente-desktop">
        <ComputerIcon color="action" sx={{ fontSize: 48, mb: 1 }} />
        <Typography variant="h6" gutterBottom>
          {titulo ? `${titulo}: ` : ''}disponível no computador
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Esta é uma tela de configuração, feita para telas maiores. Abra o sistema num computador para usá-la.
        </Typography>
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ minHeight: 44 }}>
          Voltar
        </Button>
      </Paper>
    </Box>
  )
}
